import type React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { Info } from '@vlabs/monokit/shared/ui/info';
import { useTranslation, Trans } from 'react-i18next';

import st from './PermissionTagInfo.module.sass';

export function PermissionTagInfo(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={st.Container}>
      <Info
        icon={<InfoCircleFilledIcon className={st.InfoIcon} />}
        title={t('permission-tag-page:permission_tag_info.title')}
      >
        <div className={st.Description}>
          <Trans
            components={{
              p: <p />,
              span: <span />,
              ul: <ul />,
              li: <li />,
              footer: <footer />,
            }}
            i18nKey="permission-tag-page:permission_tag_info.content"
          />
        </div>
      </Info>
    </div>
  );
}
